import Vue from "vue";
import Router from "vue-router";
import Home from "../../home/Home.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/ourStory",
      name: "ourStory",
      component: () => import("../../ourStory/OurStory.vue")
    },
    {
      path: "/guestbook",
      name: "guestbook",
      component: () => import("../../guestbook/Guestbook.vue")
    },
    {
      path: "/wedding-abc",
      name: "wedding-abc",
      component: () => import("../../weddingAbc/WeddingAbc.vue")
    },
    {
      path: "/location",
      name: "location",
      component: () => import("../../location/Location.vue")
    },
    {
      path: "/contact",
      name: "contact",
      component: () => import("../../contact/Contact.vue")
    }
  ]
});
